import React from 'react';

const ConfirmModal = ({ isOpen, title = 'Are you sure?', message, additionalContent, confirmText = 'Confirm', cancelText = 'Cancel', onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay-mobile">
      <div className="modal-container-mobile">
        <div className="modal-header-mobile">
          <h3 className="modal-title text-primary text-center">{title}</h3>
        </div>
        <div className="modal-body-mobile">
          <p className="text-secondary text-center">{message}</p>
          {additionalContent && (
            <div className="mt-4 flex justify-center">
              {additionalContent}
            </div>
          )}
        </div>
        <div className="modal-footer-mobile">
          <div className="modal-footer-content">
            <button
              onClick={onCancel}
              className="btn-secondary mr-4 min-w-[120px]"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              className="btn-danger min-w-[120px]"
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;


